import { render, staticRenderFns } from "./justificarPendencia.vue?vue&type=template&id=2387ceec"
import script from "./justificarPendencia.vue?vue&type=script&lang=js"
export * from "./justificarPendencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports